// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preference-number {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--input-element-gap);
  font-size: var(--font-size-l);

  > label {
    flex-grow: 1;
  }
}

.preference-number-disabled {
  color: var(--text-color-disabled);
}

.preference-number-slider {
  width: 175px !important;
}

.preference-number-input {
  width: 125px !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/preference-inputs/preference-number/PreferenceNumber.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;;EAE7B;IACE,YAAY;EACd;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".preference-number {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--input-element-gap);\n  font-size: var(--font-size-l);\n\n  > label {\n    flex-grow: 1;\n  }\n}\n\n.preference-number-disabled {\n  color: var(--text-color-disabled);\n}\n\n.preference-number-slider {\n  width: 175px !important;\n}\n\n.preference-number-input {\n  width: 125px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
